module.exports = __webpack_public_path__ + "static/media/faq-4.95f9b528.png";